<script setup lang="ts">
import { defineEmits } from "vue";
import { useGlobalStore } from "@/store/global";

const globalStore = useGlobalStore();
defineEmits(["close-event", "to-date"]);

const labels = {
  retry: globalStore.sitecoreData.search.not_found_retry,
  notFound: globalStore.sitecoreData.search.not_found
};

const props = defineProps<{ ids: string[] }>();
</script>

<template>
  <div class="search-result-error">
    <mc-notification
      appearance="error"
      fit="small"
      icon="exclamation-octagon"
      closable
      data-test="error-message-container"
      @close="$emit('close-event', $event)"
    >
      <span>
        {{ labels.notFound }}
        <strong>{{ Array.isArray(props.ids) ? props.ids.join(", ") : "" }}</strong>
        {{ labels.retry }}
      </span>
    </mc-notification>
  </div>
</template>
